/**
 * Filipino: Workflows P5-6, ang Ipakita ang artikulo (`show_article`) at Magdagdag ng buod na tala (`add_summary_note`).
 * Kapareho ng hugis ng English na teksto; isinasama sa `engage.workflows`.
 */
export const workflowsContent = {
  steps: { show_article: "Ipakita ang artikulo", add_summary_note: "Magdagdag ng buod na tala" },
  summaries: {
    show_article: "{{source}}",
    add_summary_note: "AI na buod ng usapan",
    add_summary_note_notify: "AI na buod ng usapan, ipinaaalam sa naka-assign",
  },
  incomplete: { article: "Piliin ang artikulong ipapakita" },
  translationKinds: { label: "Button" },
  reasons: {
    audience: "Hindi bukas sa bisitang ito ang source",
    source_unavailable: "Wala na ang source, hindi pa handa o hindi na pampubliko",
    too_short: "Masyadong maikli ang usapan para ibuod",
    summary_rate_limited: "Napakaraming buod ngayong oras para sa usapang ito o sa workspace",
    no_credits: "Wala nang AI credits",
    no_conversation: "Wala pang usapan",
    plan: "Hindi na kasama sa plan ang hakbang na ito",
    summary_unavailable: "Walang magagamit na model",
    already_done: "Naisulat na ng hakbang na ito ang tala nito",
    preview: "Playground: walang isinusulat o sinisingil",
    provider_error: "Hindi sumagot ang model sa tamang oras",
    empty_summary: "Walang magagamit sa sagot ng model",
  },
  outcomes: { shown: "Naipakita", written: "Naisulat ang tala", errored: "Hindi naisulat" },
  channelNotes: {
    steps: {
      show_article: {
        web: "Web chat, web app at mobile: isang card na may pamagat, ang teksto mo at button na nagbubukas ng link sa bagong tab.",
        messenger: "Messenger: isang mensahe na may isang button na nagbubukas ng link. Pinuputol sa 20 character ang pamagat ng button.",
        email: "Email: nakasulat sa mensahe ang link, ang pamagat ang teksto nito.",
        api: "Developer API: isang linya na may pamagat at address, gaya ng “Tuition plans: https://…”.",
      },
      add_summary_note: { behind: "Tumatakbo sa likod ng eksena sa lahat ng channel. Para sa team mo sa Inbox ang tala at hindi ito ipinapadala sa bisita." },
    },
  },
  article: {
    intro: "Nagpapakita ng card na may link sa isang pahina mula sa Knowledge mo. Bumubukas ito sa bagong tab.",
    previewTitle: "Pamagat ng artikulo",
    preview: "Ganito ang itsura ng card",
    text: "Teksto sa card",
    textHint: "Opsyonal. Isang linya kung tungkol saan ang artikulo.",
    label: "Label ng button",
    labelHint: "Opsyonal. “Buksan ang artikulo” kapag walang laman.",
    audience: "Ang mga bisitang bukas sa kanila ang source lang ang makakakita ng card. Kung internal, nabura o hindi na pampubliko ang source, walang ipapakita at magpapatuloy ang workflow.",
    source: {
      loading: "Naglo-load ng mga source",
      label: "Knowledge source",
      hint: "Mga website na may pampublikong https address. Nasa pribadong storage ang file at walang link na mabubuksan ng bisita.",
      choose: "Pumili ng source",
      search: "Maghanap ng source",
      searchPlaceholder: "Hanapin ayon sa pamagat o address",
      noMatches: "Walang source na tumutugma sa “{{query}}”.",
      unavailableOption: "Hindi magagamit na source",
      unavailable: "Wala na ang source na ito, hindi pa handa o walang pampublikong link. Pumili ng iba.",
      loadFailedTitle: "Hindi namin ma-load ang mga source",
      loadFailedBody: "Suriin ang koneksyon at subukan ulit.",
      retry: "Subukan ulit",
      noAccess: "Kailangan mo ng pahintulot na tumingin sa Knowledge para makita ang mga source. Humingi ng tulong sa admin.",
      emptyTitle: "Wala pang source na may pampublikong link",
      emptyBody: "Magdagdag ng website sa Knowledge at hintaying maging handa ito. Pribado ang mga file, kaya hindi ito malilink ng card.",
      openKnowledge: "Buksan ang Knowledge",
    },
    page: {
      loading: "Naglo-load ng mga pahina",
      label: "Isang pahina ng site",
      hint: "Opsyonal. Ipapakita ng card ang pamagat ng pahinang iyon at bubuksan ang address nito.",
      wholeSite: "Ang pangunahing link ng site",
      search: "Maghanap ng pahina",
      searchPlaceholder: "Hanapin ayon sa pamagat o address",
      noMatches: "Walang pahinang tumutugma sa “{{query}}”.",
      unavailableOption: "Hindi magagamit na pahina",
      none: "Walang na-crawl na pahina sa site na ito na mapagpipilian. Ang sariling address ng site ang ili-link ng card.",
      loadFailed: "Hindi namin ma-load ang mga pahina.",
      retry: "Subukan ulit",
    },
  },
  summaryNote: {
    badge: "AI",
    planBadge: "Plan na {{plan}}",
    plan: "Kailangan ng plan na {{plan}} o mas mataas para sa buod na tala.",
    explainer: "Sumusulat ng AI na buod ng usapan bilang internal na tala. Gumagamit ng {{credits}} AI credit. Nilalaktawan kapag wala pang {{min}} mensahe ang usapan.",
    notify: "Ipaalam sa naka-assign",
    notifyHint: "Magpapadala ng notification sa taong naka-assign ang usapan.",
    privacy: "Inaalis ang mga personal na detalye gaya ng email at numero ng telepono bago makarating sa model ang usapan. Para lang sa team mo ang tala.",
  },
} as const;
